/* bretterkiste – Modern Layer: 3D-Tilt, Lichtreflex, Scroll-Reveal, Hero-Parallaxe.
   Ohne Wirkung bei Touch-Geräten (Tilt) und bei "Bewegung reduzieren". */
(function () {
  var root = document.documentElement;
  if (!root.classList.contains('bk-modern')) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* Kopfzeile bekommt beim Scrollen mehr Tiefe. Weiter unten zeigt sie bis 1440 px nur die fünf Symbole – ohne Logo
     und Menü-Knopf (Inhaber 28.10.2026, CSS „Gescrollte Kopfleiste“); zwei Schwellen, damit sie an der Grenze nicht
     flackert. bk-kopf-zurueck lässt Logo und Menü-Knopf beim Zurückkommen weich einblenden. */
  var kopfKompakt = false;
  function onScrollHeader() {
    var y = window.scrollY;
    root.classList.toggle('m-scrolled', y > 8);
    if (kopfKompakt ? y < 60 : y > 140) {
      kopfKompakt = !kopfKompakt;
      root.classList.toggle('bk-kopf-kompakt', kopfKompakt);
      root.classList.toggle('bk-kopf-zurueck', !kopfKompakt);
    }
  }
  window.addEventListener('scroll', onScrollHeader, { passive: true });
  onScrollHeader();

  /* 3D-Tilt mit Lichtreflex */
  var TILT_SELECTOR = '.bk-cat-tile, .wp-card, .cc-card, .sh-card';
  var MAX_DEG = 7;
  function bindTilt(el) {
    if (el.dataset.mTilt) return;
    el.dataset.mTilt = '1';
    el.classList.add('m-tilt');
    var raf = 0;
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width;
      var y = (e.clientY - r.top) / r.height;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        el.classList.add('m-tilt--active');
        el.style.setProperty('--m-ry', ((x - .5) * 2 * MAX_DEG).toFixed(2) + 'deg');
        el.style.setProperty('--m-rx', ((.5 - y) * 2 * MAX_DEG).toFixed(2) + 'deg');
        el.style.setProperty('--m-mx', (x * 100).toFixed(1) + '%');
        el.style.setProperty('--m-my', (y * 100).toFixed(1) + '%');
      });
    });
    el.addEventListener('pointerleave', function () {
      cancelAnimationFrame(raf);
      el.classList.remove('m-tilt--active');
      el.style.setProperty('--m-rx', '0deg');
      el.style.setProperty('--m-ry', '0deg');
    });
  }

  /* Einblenden beim Scrollen, Elemente einer Gruppe leicht versetzt */
  var REVEAL_SELECTOR = '.bk-cat-tile, .wp-section__intro, .wp-card, .bk-advice__box, .cc-card, .sh-card, .sh-shipping, .sh-step, .pd-info-outer, .bk-site-footer, ' +
    '.impr-legal-block, .impr-info-card, .agb-legal-block, .ds-legal-block, .wr-legal-block, .faqp-group, .faqp-cta, ' +
    '.kontakt-form-wrap, .kontakt-info, .vs-card, .vs-section, .vs-cta, .about-section, .about-value-card, .about-partner-card, .about-stat, .about-cta-block';
  var io = ('IntersectionObserver' in window && !reduceMotion) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      en.target.classList.add('m-in');
      io.unobserve(en.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: .08 }) : null;

  function bindReveal(el) {
    if (!io || el.dataset.mReveal || el.closest('.bk-bestseller-grid')) return;   /* Karussell-Karten steuern Deckkraft/Größe selbst */
    el.dataset.mReveal = '1';
    var siblings = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
    el.style.setProperty('--m-delay', (Math.min(siblings, 5) * 70) + 'ms');
    el.classList.add('m-reveal');
    io.observe(el);
  }

  function scan(scope) {
    if (finePointer && !reduceMotion) scope.querySelectorAll(TILT_SELECTOR).forEach(bindTilt);
    scope.querySelectorAll(REVEAL_SELECTOR).forEach(bindReveal);
  }

  /* Produktkarussell: eine Karte in der Mitte, die Nachbarn ragen links und rechts hinein.
     Endlos: die Karten werden davor und dahinter kopiert (für Screenreader/Tastatur unsichtbar);
     landet man in einer Kopie, springt die Reihe unbemerkt auf das Original zurück. */
  var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg>';
  function initCarousel(track) {
    if (track.dataset.mCarousel) return;
    track.dataset.mCarousel = '1';
    var originals = Array.prototype.slice.call(track.children);
    var n = originals.length;
    if (!n) return;
    var wrap = document.createElement('div');
    wrap.className = 'm-carousel';
    track.parentNode.insertBefore(wrap, track);
    wrap.appendChild(track);
    var label = (track.closest('section') || {}).getAttribute ? track.closest('section').getAttribute('aria-label') : '';
    track.setAttribute('role', 'region');
    track.setAttribute('aria-label', (label || 'Produkte') + ' – zum Blättern wischen');
    track.tabIndex = 0;

    var loop = n >= 3;
    function makeClone(el) {
      var c = el.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.setAttribute('tabindex', '-1');
      c.classList.add('m-clone');
      c.querySelectorAll('img').forEach(function (img) { img.loading = 'eager'; });
      return c;
    }
    if (loop) {
      var before = document.createDocumentFragment(), after = document.createDocumentFragment();
      originals.forEach(function (el) { before.appendChild(makeClone(el)); after.appendChild(makeClone(el)); });
      track.insertBefore(before, track.firstChild);
      track.appendChild(after);
    }
    var cards = Array.prototype.slice.call(track.children);
    var active = -1;

    function centerOf(el) { return el.offsetLeft + el.offsetWidth / 2 - track.clientWidth / 2; }
    function setWidth() { return loop ? cards[n].offsetLeft - cards[0].offsetLeft : 0; }
    function jumpTo(left) {
      track.style.scrollBehavior = 'auto';
      track.style.scrollSnapType = 'none';
      track.scrollLeft = left;
      track.offsetWidth; /* Layout erzwingen, bevor Snap/Smooth wieder angehen */
      track.style.scrollSnapType = '';
      track.style.scrollBehavior = '';
    }
    function nearest() {
      var mid = track.scrollLeft + track.clientWidth / 2, best = 0, bestD = Infinity;
      cards.forEach(function (c, i) {
        var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid);
        if (d < bestD) { bestD = d; best = i; }
      });
      return best;
    }
    function markActive() {
      var i = nearest();
      if (i === active) return;
      if (active >= 0 && cards[active]) cards[active].classList.remove('is-active');
      cards[i].classList.add('is-active');
      active = i;
    }
    function settle() {
      if (!loop) return;
      var i = nearest();
      if (i < n) jumpTo(track.scrollLeft + setWidth());
      else if (i >= 2 * n) jumpTo(track.scrollLeft - setWidth());
      markActive();
    }
    function go(step) {
      var i = nearest() + step;
      if (loop && (i < 0 || i >= cards.length)) { settle(); i = nearest() + step; }
      i = Math.max(0, Math.min(cards.length - 1, i));
      track.scrollTo({ left: centerOf(cards[i]), behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    function makeBtn(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'm-carousel__btn m-carousel__btn--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Vorheriges Produkt' : 'Nächstes Produkt');
      b.innerHTML = dir === 'prev' ? ARROW : ARROW.replace('15 18 9 12 15 6', '9 18 15 12 9 6');
      b.addEventListener('click', function () { go(dir === 'prev' ? -1 : 1); });
      wrap.appendChild(b);
      return b;
    }
    makeBtn('prev'); makeBtn('next');
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); go(e.key === 'ArrowLeft' ? -1 : 1); }
    });

    var idle = 0;
    track.addEventListener('scroll', function () {
      requestAnimationFrame(markActive);
      clearTimeout(idle);
      idle = setTimeout(settle, 140);
    }, { passive: true });
    if ('onscrollend' in window) track.addEventListener('scrollend', function () { clearTimeout(idle); settle(); });

    function start() { jumpTo(centerOf(cards[loop ? n : 0])); markActive(); }
    start();
    var w = track.clientWidth;
    window.addEventListener('resize', function () {
      if (track.clientWidth === w) return;
      w = track.clientWidth;
      var i = nearest();
      jumpTo(centerOf(cards[i]));
    });
  }

  /* Hero: Foto bewegt sich langsamer als die Seite, Glaskarte folgt der Maus */
  function heroEffects() {
    var hero = document.querySelector('.hc-hero');
    if (!hero || reduceMotion) return;
    var bilder = hero.querySelectorAll('.hc-hero__img, .hc-hero__video');
    var card = hero.querySelector('.hc-hero-glass');
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = Math.min(window.scrollY, hero.offsetHeight);
        var t = 'translate3d(0,' + (y * .18).toFixed(1) + 'px,0) scale(1.08)';
        bilder.forEach(function (el) { el.style.transform = t; });
        ticking = false;
      });
    }, { passive: true });
    if (card && finePointer) {
      hero.addEventListener('pointermove', function (e) {
        var r = hero.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - .5;
        var y = (e.clientY - r.top) / r.height - .5;
        card.style.transform = 'rotateY(' + (x * 6).toFixed(2) + 'deg) rotateX(' + (-y * 6).toFixed(2) + 'deg)';
      });
      hero.addEventListener('pointerleave', function () { card.style.transform = ''; });
    }
  }

  /* Hero-Video: lädt erst nach dem Seitenaufbau, Größe passend zur Bildschirmbreite.
     Kein Video bei "Bewegung reduzieren" oder Datensparmodus – dann bleibt das Standbild.
     Pause-Knopf (WCAG 2.2.2) merkt sich die Wahl; außerhalb des Sichtbereichs pausiert das Video. */
  function heroVideo() {
    var video = document.querySelector('.hc-hero__video');
    if (!video) return;
    var knopf = document.querySelector('.hc-hero__pause');
    var sparen = navigator.connection && navigator.connection.saveData;
    if (reduceMotion || sparen) return;
    var w = window.innerWidth * Math.min(window.devicePixelRatio || 1, 2);
    var src = w <= 900 ? video.dataset.srcS : (w <= 1600 ? video.dataset.srcM : video.dataset.srcL);
    if (!src) return;
    var angehalten = false;
    try { angehalten = localStorage.getItem('bk-hero-video') === 'pause'; } catch (e) {}
    var sichtbar = true;
    function setzeKnopf() {
      if (!knopf) return;
      knopf.hidden = false;
      knopf.setAttribute('aria-pressed', angehalten ? 'true' : 'false');
      knopf.setAttribute('aria-label', angehalten ? 'Video abspielen' : 'Video anhalten');
    }
    function abspielen() {
      if (angehalten || !sichtbar || document.hidden) { video.pause(); return; }
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }
    video.addEventListener('playing', function () { video.classList.add('is-bereit'); }, { once: true });
    video.src = src;
    video.muted = true;
    abspielen();
    setzeKnopf();
    if (knopf) knopf.addEventListener('click', function () {
      angehalten = !angehalten;
      try { localStorage.setItem('bk-hero-video', angehalten ? 'pause' : 'play'); } catch (e) {}
      setzeKnopf();
      abspielen();
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sichtbar = entries[0].isIntersecting;
        abspielen();
      }).observe(video);
    }
    document.addEventListener('visibilitychange', abspielen);
  }

  function init() {
    document.querySelectorAll('.bk-bestseller-grid').forEach(initCarousel);
    scan(document);
    heroEffects();
    if (document.readyState === 'complete') heroVideo();
    else window.addEventListener('load', heroVideo, { once: true });
    /* Inhalte, die per Script nachgeladen werden (z. B. Warenkorb, Filter) */
    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n.parentElement || n); });
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
